"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectedAudience = void 0;
var _react = require("react");
var _SelectedAudience = require("./SelectedAudience.styles");
var _ExpandableList = require("../../../../../Data/ExpandableList");
var _Chip = require("../../../../../UI/Chip");
var _hooks = require("../../../../../hooks");
var _Tooltip = require("../../../../../UI/Tooltip");
var _StudentsListItem = require("../AudienceSelectList/partials/AudienceList/partials/StudentsListItem");
var _AudiencePickerProvider = require("../../../provider/AudiencePickerProvider.helpers");
var _AudiencePicker = require("../../../AudiencePicker.helpers");
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var SelectedAudience = function SelectedAudience(props) {
  var _props$originalSelect = props.originalSelectedClassesIds,
    originalSelectedClassesIds = _props$originalSelect === void 0 ? [] : _props$originalSelect,
    _props$originalSelect2 = props.originalSelectedGroupsIds,
    originalSelectedGroupsIds = _props$originalSelect2 === void 0 ? [] : _props$originalSelect2,
    _props$originalSelect3 = props.originalSelectedStudentsIds,
    originalSelectedStudentsIds = _props$originalSelect3 === void 0 ? [] : _props$originalSelect3,
    selectedClassesIds = props.selectedClassesIds,
    selectedGroupsIds = props.selectedGroupsIds,
    selectedStudentsIds = props.selectedStudentsIds,
    classesMapper = props.classesMapper,
    groupsMapper = props.groupsMapper,
    studentsMapper = props.studentsMapper,
    onDisableItemClick = props.onDisableItemClick,
    onDeleteItem = props.onDeleteItem,
    onSelectedChanged = props.onSelectedChanged,
    isReadOnly = props.isReadOnly,
    readOnlyGroupsMapper = props.readOnlyGroupsMapper,
    readOnlyStudentsMapper = props.readOnlyStudentsMapper,
    cantRemoveMessage = props.cantRemoveMessage,
    setCantRemoveMessage = props.setCantRemoveMessage;
  var _useDeviceData = (0, _hooks.useDeviceData)(),
    isMobileView = _useDeviceData.isMobileView;
  var _useState = (0, _react.useState)([]),
    _useState2 = _slicedToArray(_useState, 2),
    items = _useState2[0],
    setItems = _useState2[1];
  var styles = (0, _SelectedAudience.useStyles)(props);
  var handleRemoveAllItems = function handleRemoveAllItems() {
    if (onDeleteItem && (!(0, _AudiencePicker.checkSubset)(selectedClassesIds !== null && selectedClassesIds !== void 0 ? selectedClassesIds : [], originalSelectedClassesIds) || !(0, _AudiencePicker.checkSubset)(selectedGroupsIds !== null && selectedGroupsIds !== void 0 ? selectedGroupsIds : [], originalSelectedGroupsIds) || !(0, _AudiencePicker.checkSubset)(selectedStudentsIds !== null && selectedStudentsIds !== void 0 ? selectedStudentsIds : [], originalSelectedStudentsIds))) {
      setCantRemoveMessage(onDeleteItem());
    }
    onSelectedChanged({
      selectedGroupsIds: (selectedGroupsIds === null || selectedGroupsIds === void 0 ? void 0 : selectedGroupsIds.filter(function (id) {
        return readOnlyGroupsMapper[id];
      })) || [],
      selectedClassesIds: (selectedClassesIds === null || selectedClassesIds === void 0 ? void 0 : selectedClassesIds.filter(function (id) {
        return readOnlyGroupsMapper[id];
      })) || [],
      selectedStudentsIds: (selectedStudentsIds === null || selectedStudentsIds === void 0 ? void 0 : selectedStudentsIds.filter(function (id) {
        return readOnlyStudentsMapper[id];
      })) || []
    });
  };
  var handleDisabledItemClick = (0, _react.useCallback)(function () {
    if (onDisableItemClick) {
      setCantRemoveMessage(onDisableItemClick());
    }
  }, [onDisableItemClick, setCantRemoveMessage]);
  var handleDeleteItem = (0, _react.useCallback)(function (currentAudience, originalAudience) {
    if (onDeleteItem && !(0, _AudiencePicker.checkSubset)(currentAudience, originalAudience)) {
      setCantRemoveMessage(onDeleteItem());
    }
  }, [onDeleteItem, setCantRemoveMessage]);
  (0, _react.useEffect)(function () {
    var basicChip = {
      color: 'basic',
      size: 'small',
      isSelected: true,
      id: '',
      label: ''
    };
    var _items = [];
    var handleClassRemove = function handleClassRemove(id) {
      var _selectedClassesIds$f;
      var selectedClassesIdsAfterRemove = (_selectedClassesIds$f = selectedClassesIds === null || selectedClassesIds === void 0 ? void 0 : selectedClassesIds.filter(function (_id) {
        return _id !== id;
      })) !== null && _selectedClassesIds$f !== void 0 ? _selectedClassesIds$f : [];
      handleDeleteItem(selectedClassesIdsAfterRemove, originalSelectedClassesIds);
      onSelectedChanged({
        selectedGroupsIds: selectedGroupsIds,
        selectedStudentsIds: selectedStudentsIds,
        selectedClassesIds: selectedClassesIdsAfterRemove
      });
    };
    var handleGroupRemove = function handleGroupRemove(id) {
      var _selectedGroupsIds$fi;
      var selectedGroupsIdsAfterRemove = (_selectedGroupsIds$fi = selectedGroupsIds === null || selectedGroupsIds === void 0 ? void 0 : selectedGroupsIds.filter(function (_id) {
        return _id !== id;
      })) !== null && _selectedGroupsIds$fi !== void 0 ? _selectedGroupsIds$fi : [];
      handleDeleteItem(selectedGroupsIdsAfterRemove, originalSelectedGroupsIds);
      onSelectedChanged({
        selectedClassesIds: selectedClassesIds,
        selectedStudentsIds: selectedStudentsIds,
        selectedGroupsIds: selectedGroupsIdsAfterRemove
      });
    };
    var handleStudentRemove = function handleStudentRemove(id) {
      var _selectedStudentsIds$;
      var selectedStudentsIdsAfterRemove = (_selectedStudentsIds$ = selectedStudentsIds === null || selectedStudentsIds === void 0 ? void 0 : selectedStudentsIds.filter(function (_id) {
        return _id !== id;
      })) !== null && _selectedStudentsIds$ !== void 0 ? _selectedStudentsIds$ : [];
      handleDeleteItem(selectedStudentsIdsAfterRemove, originalSelectedStudentsIds);
      onSelectedChanged({
        selectedClassesIds: selectedClassesIds,
        selectedGroupsIds: selectedGroupsIds,
        selectedStudentsIds: selectedStudentsIdsAfterRemove
      });
    };
    selectedClassesIds === null || selectedClassesIds === void 0 ? void 0 : selectedClassesIds.forEach(function (id) {
      if (classesMapper && classesMapper[id]) {
        var isDisabled = isReadOnly || readOnlyGroupsMapper[id];
        _items.push({
          position: 'bottom',
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip, _objectSpread(_objectSpread({}, basicChip), {}, {
            icon: isDisabled ? null : 'Close',
            id: id,
            label: classesMapper[id].group.name,
            isDisabled: isDisabled,
            onClick: isDisabled ? handleDisabledItemClick : undefined,
            onIconClick: function onIconClick() {
              handleClassRemove(id);
            }
          })),
          children: null
        });
      }
    });
    selectedGroupsIds === null || selectedGroupsIds === void 0 ? void 0 : selectedGroupsIds.forEach(function (id) {
      if (groupsMapper && groupsMapper[id]) {
        var isDisabled = isReadOnly || readOnlyGroupsMapper[id];
        _items.push({
          position: 'bottom',
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip, _objectSpread(_objectSpread({}, basicChip), {}, {
            icon: isDisabled ? null : 'Close',
            id: id,
            label: groupsMapper[id].group.name,
            isDisabled: isDisabled,
            onClick: isDisabled ? handleDisabledItemClick : undefined,
            onIconClick: function onIconClick() {
              handleGroupRemove(id);
            }
          })),
          children: null
        });
      }
    });
    selectedStudentsIds === null || selectedStudentsIds === void 0 ? void 0 : selectedStudentsIds.forEach(function (id) {
      if (studentsMapper && studentsMapper[id]) {
        var isDisabled = isReadOnly || readOnlyStudentsMapper[id];
        _items.push({
          position: 'bottom',
          anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Chip.Chip, _objectSpread(_objectSpread({}, basicChip), {}, {
            icon: isDisabled ? null : 'Close',
            id: id,
            label: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student),
            isDisabled: isDisabled,
            onClick: isDisabled ? handleDisabledItemClick : undefined,
            onIconClick: function onIconClick() {
              handleStudentRemove(id);
            }
          })),
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_StudentsListItem.StudentsListItem, _objectSpread(_objectSpread({}, props), {}, {
            id: id,
            fullName: (0, _AudiencePickerProvider.getStudentFullName)(studentsMapper[id].student),
            isTooltip: true
          }))
        });
      }
    });
    setItems(_items);
  }, [classesMapper, groupsMapper, handleDisabledItemClick, isMobileView, isReadOnly, onDisableItemClick, onDeleteItem, onSelectedChanged, originalSelectedClassesIds, originalSelectedGroupsIds, originalSelectedStudentsIds, props, readOnlyGroupsMapper, readOnlyStudentsMapper, selectedClassesIds, selectedGroupsIds, selectedStudentsIds, studentsMapper, handleDeleteItem]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-AudiencePicker__selected-audience'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandableList.ExpandableList, {
      ItemTag: _Tooltip.Tooltip,
      items: items,
      itemHeight: 36,
      isWithRemoveAllButton: isMobileView && !isReadOnly,
      onRemoveAllItems: handleRemoveAllItems
    }), cantRemoveMessage && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-AudiencePicker__cannot-remove-message'],
      dangerouslySetInnerHTML: {
        __html: cantRemoveMessage
      }
    })]
  });
};
exports.SelectedAudience = SelectedAudience;